module.exports = __webpack_public_path__ + "img/qrcode.fd475491.png";